import { FC } from "react";
import { Price } from "src/Modules/Flights/constants";
import { formatNumber } from "src/utility";
import { explode } from "src/utility/objects";
import { useTranslation } from "react-i18next";

const PriceCard: FC<{ priceObject: Price }> = ({ priceObject }) => {
  const { t } = useTranslation();
  const { total, priceInPoints, currency } = explode(priceObject, { total: 0, currency: "", priceInPoints: 0 });
  return (
    <div className="flex flex-col items-start justify-start md:items-center">
      <div className="text-xs text-font-subtle font-semibold">{t("Flights.listing.totalPrice")}</div>
      <div className="text-font-default flex items-center justify-start gap-2 md:text-xl">
        <span className="font-bold">{formatNumber(total)}</span>
        <span className="text-xs font-semibold">{currency}</span>
      </div>
      <div className="text-font-active flex items-start justify-center gap-2 md:text-xl">
        <span className="font-bold">{formatNumber(priceInPoints)}</span>
        <span className="text-xs font-semibold">{t("Flights.listing.pts")}</span>
      </div>
    </div>
  );
};

export default PriceCard;
